import React from 'react'
import { Modal } from '../../../../components/Modal/Modal'
import { Upsell } from '../../../Plan/DeltaTrial/Upsell/Upsell'
import { EnableOAuth2AppModal } from './EnableOAuth2AppModal'
import { DisableOAuth2AppModal } from './DisableOAuth2AppModal'
import { RevokeMyOAuth2AppAccessModal } from './RevokeMyOAuth2AppAccessModal'
import { OAuth2App, ShortOAuth2App } from '../../../../store/auth/auth'
import { createDeltaTrialFeatureFromApp } from '../utils'

export type OAuth2AppsModalType = 'upgrade' | 'enable' | 'disable' | 'revoke' | null

interface OAuth2AppsModalManagerProps {
  oAuth2App: OAuth2App | ShortOAuth2App
  activeModal: OAuth2AppsModalType
  onClose: () => void
}

export const OAuth2AppsModalManager: React.FC<OAuth2AppsModalManagerProps> = ({ oAuth2App, activeModal, onClose }) => {
  const feature = createDeltaTrialFeatureFromApp(oAuth2App)

  return (
    <>
      <Modal
        size='xl'
        className='d-flex'
        bodyClassName='p-0'
        show={activeModal === 'upgrade'}
        onHide={() => onClose()}
        body={
          <div className='d-flex align-items-center justify-content-center position-relative zapier-promo-modal'>
            <Upsell feature={feature} />
            <i className='bi bi-x-lg position-absolute zapier-promo-modal-hide-button cursor-pointer' onClick={() => onClose()} />
          </div>
        }
        centered
      />
      <EnableOAuth2AppModal oAuth2App={oAuth2App} show={activeModal === 'enable'} onHide={() => onClose()} />
      <DisableOAuth2AppModal oAuth2App={oAuth2App} show={activeModal === 'disable'} onHide={() => onClose()} />
      <RevokeMyOAuth2AppAccessModal oAuth2App={oAuth2App} show={activeModal === 'revoke'} onHide={() => onClose()} />
    </>
  )
}
